import styled from 'styled-components';
import AcAvatar from 'dc/AcAvatar';
import { Typ20 } from 'dc/Typ';

export const AvatarWrapper = styled.div`
  height: 96px;
  width: 96px;
  margin: 0 auto 16px;
`;

export const AvatarImage = styled(AcAvatar)``;

export const ActiveSinceText = styled(Typ20)`
  color: #546e7a;
  text-align: center;
  width: 100%;
  margin-bottom: 24px;
`;
